import {Component , OnInit , ViewEncapsulation} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {FuseConfigService} from "../../core/services/config.service";
import {ActivatedRoute} from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";
import {UserService} from "../../core/services/users.service";

@Component({
    selector: 'fuse-quick-panel',
    templateUrl: './quick-panel.component.html',
    styleUrls: ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FuseQuickPanelComponent implements OnInit {
  doc;
  edit = false;
  public editor;
  public editorContent = ``;
  public editorConfig = {
    placeholder: "",
    modules: {
    },
  };
  htmlSat;
  section;
  id;
  active = false;
  title;
  constructor (private http: HttpClient , private fuseConfig: FuseConfigService , private activeRouter: ActivatedRoute , private satinaizer: DomSanitizer , private userService: UserService) {

    fuseConfig.documentstion.subscribe((res) => {
      if (res) {
        this.id = null;
        this.htmlSat = null;
        this.edit = false;
        this.title = null;
        this.active = false;
        this.editorContent = '';
        this.section = activeRouter.snapshot[ '_routerState' ].url.split('?')[ 0 ] , 'router';
        this.userService.getDocumentation(activeRouter.snapshot[ '_routerState' ].url.split('?')[ 0 ]).subscribe((result: any) => {
          this.doc = result;
          if (result.data) {
            this.htmlSat = this.satinaizer.bypassSecurityTrustHtml(result.data.html);
            this.editorContent = result.data.html;
            this.id = result.data.id;
            this.title = result.data.title;
            this.active = result.data.active;
          }
        });
      }
    });


  }

  ngOnInit () {


  }



  saveDoc () {
      this.userService.addDocumentation({section: this.section, html: this.editorContent, id: this.id, title: this.title, active: this.active}).subscribe((res: any) => {
        if (res) {
          this.edit = false;
          this.doc = res;
          if (res.data) {
            this.htmlSat = this.satinaizer.bypassSecurityTrustHtml(res.data.html);
            this.editorContent = res.data.html;
            this.id = res.data.id;
            this.title = res.data.title;
            this.active = res.data.active;
          }
        }
      });
  }
}
